import { FeatureCollection } from 'geojson'
import { useFilterResults, useHasFilters } from 'map-filter-view'
import { useMemo } from 'react'

export const useFilteredGeojson = (
  geojson?: FeatureCollection
): FeatureCollection => {
  const hasFilters = useHasFilters()
  const features = useFilterResults()

  const filteredGeojson = useMemo(() => {
    const filteredGeojson = {
      type: 'FeatureCollection',
      features: hasFilters && features.length ? features : []
    }

    return hasFilters ? filteredGeojson : geojson
  }, [features, geojson, hasFilters])

  return filteredGeojson as FeatureCollection
}
